import { render, staticRenderFns } from "./platformCouponManage.vue?vue&type=template&id=d52fbf48&scoped=true"
import script from "./platformCouponManage.vue?vue&type=script&lang=js"
export * from "./platformCouponManage.vue?vue&type=script&lang=js"
import style0 from "./platformCouponManage.vue?vue&type=style&index=0&id=d52fbf48&lang=scss"
import style1 from "./platformCouponManage.vue?vue&type=style&index=1&id=d52fbf48&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52fbf48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d52fbf48')) {
      api.createRecord('d52fbf48', component.options)
    } else {
      api.reload('d52fbf48', component.options)
    }
    module.hot.accept("./platformCouponManage.vue?vue&type=template&id=d52fbf48&scoped=true", function () {
      api.rerender('d52fbf48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platformCouponManage/platformCouponManage.vue"
export default component.exports